import React from 'react';
import Login from './Login';
import styles from './LoginPage.module.css';

const LoginPage = () => {
  return (
    <div className={styles.loginPage}>
      <div className={styles.inner}>
        <h1 className={styles.title}>Log into Mythic Commander</h1>
        <div className={styles.loginWrapper}>
          <Login />
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
